import { PaletteOptions } from '@mui/material';

const modernGoldPalette: PaletteOptions = {
  primary: {
    50: '#1C1500',
    100: '#3B2C00',
    200: '#7A5F00',
    300: '#B78F00',
    400: '#E0B800',
    500: '#F4CD1F',
    600: '#FFD148',
    700: '#FFDB52',
    800: '#FFE973',
    900: '#FFF4B1',
    main: '#FFD148',
  },
  secondary: {
    25: '#FFF9F2',
    50: '#FFF3E0',
    100: '#FFE8CC',
    200: '#FFD9A8',
    300: '#FFBE73',
    400: '#FF9E3F',
    500: '#DB7423',
    700: '#944716',
    800: '#733510',
    900: '#5A290D',
    main: '#DB7423',
  },
  error: {
    25: '#FEF0F0',
    50: '#FEE2E2',
    100: '#FED4D4',
    200: '#FEC6C6',
    300: '#FDB2B2',
    400: '#FB8C8C',
    500: '#FA6565',
    600: '#F93F3F',
    700: '#8C1D18',
    800: '#601410',
    900: '#410E0B',
    main: '#FA6565',
  },
  neutral: {
    25: '#F8F9FA',
    50: '#F3F4F6',
    100: '#E5E7EB',
    200: '#D1D5DB',
    300: '#9CA3AF',
    400: '#515a6d',
    500: '#4B5563',
    600: '#374151',
    700: '#1F2937',
    800: '#111827',
    900: '#0D111C',
    A100: '#FFFFFF1A',
  },
  info: {
    100: '#FFF5E0',
    300: '#FFE0A3',
    400: '#FFD075',
    500: '#FFC14D',
    600: '#FFB028',
    700: '#E89A12',
    800: '#A86A0C',
    main: '#FFC14D',
  },
  background: {
    default: '#1C1C20',
    paper: '#272734',
  },
  text: {
    primary: '#E5E7EB',
    secondary: '#9CA3AF',
    disabled: '#4B5563',
  },
  promoPage: {
    heading: '#FFFFFF',
    description: '#FFE973',
    duration: '#FFF4B1',
    cardBackground: '#3B2C00',
    buttonBorder: '#1C1500',
    buttonBackground: '#DB7423',
    buttonBackgroundHover: '#944716',
    separator: '#DB742373',
  },
  gradient: 'linear-gradient(91.32deg, #FFD148 0%, #DB7423 100%)',
  divider: '#333',
} as const;

export default modernGoldPalette;
